module.exports = __webpack_public_path__ + "img/info-8.6970ac5b.svg";